<div *ngFor="let toast of toastService.toasts; let i = index"
  class="toast toast-size-{{toast.size}} location-{{toast.location}}" [style.top]="i * 90 + 'px'"
  [class.tall]="!!toast.icon" [@toast] [class.vertical]="toast.vertical">

  <div class="toast-inner">
    <app-svg [src]="toast.icon" *ngIf="toast.icon" class="toast-icon color-{{toast.color}}"></app-svg>
    <div class="image-container" [class.has-bg]="toast.backgroundImage">
      <img [src]="toast.image" *ngIf="toast.image" class="toast-image" alt="">
      <img [src]="toast.backgroundImage" *ngIf="toast.backgroundImage" class="toast-bg-image"
        [style.width]="toast.backgroundImageSize + 'px'" [style.height]="toast.backgroundImageSize + 'px'" alt="">
    </div>
    <div class="toast-text" [class.has-title]="!!toast.title">
      <h3 *ngIf="toast.title" [innerHtml]="toast.title"></h3>
      <span class="standard-text" [innerHtml]="toast.message"></span>
    </div>

    <button appButton name="confirm" location="toasts" *ngIf="toast.cta" (click)="toast.cta.onClick()" spacing="full" class="toast-cta"
      [color]="toast.cta.color">
      {{toast.cta.text}}
    </button>

    <div class="separator"></div>

    <button appButton name="close" location="toasts" *ngIf="toast.closable" [iconButton]="true" height="0"
      (click)="toastService.close(toast)" color="simple" class="close-button">
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
  </div>
</div>
